export default __webpack_public_path__ + "static/media/whyalca.40daddb8.jpg";